export enum Privacy {
	PUBLIC = 'PUBLIC',
	PRIVATE = 'PRIVATE',
}

export interface ICategory {
	id: number;
	name: string;
	description: string;
	privacity: Privacy;
	createdAt: string;
	updatedAt: string;
	deleteAt: null | string;
}

export interface ICategoryDto {
	name: string;
	description: string;
	privacity: Privacy;
}
